"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.linearRing = linearRing;
exports.linearRings = linearRings;
exports.linearRingss = linearRingss;

/**
 * @module ol/geom/flat/area
 */

/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {number} end End.
 * @param {number} stride Stride.
 * @return {number} Area.
 */
function linearRing(flatCoordinates, offset, end, stride) {
  var twiceArea = 0;
  var x1 = flatCoordinates[end - stride];
  var y1 = flatCoordinates[end - stride + 1];

  for (; offset < end; offset += stride) {
    var x2 = flatCoordinates[offset];
    var y2 = flatCoordinates[offset + 1];
    twiceArea += y1 * x2 - x1 * y2;
    x1 = x2;
    y1 = y2;
  }

  return twiceArea / 2;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<number>} ends Ends.
 * @param {number} stride Stride.
 * @return {number} Area.
 */


function linearRings(flatCoordinates, offset, ends, stride) {
  var area = 0;

  for (var i = 0, ii = ends.length; i < ii; ++i) {
    var end = ends[i];
    area += linearRing(flatCoordinates, offset, end, stride);
    offset = end;
  }

  return area;
}
/**
 * @param {Array<number>} flatCoordinates Flat coordinates.
 * @param {number} offset Offset.
 * @param {Array<Array<number>>} endss Endss.
 * @param {number} stride Stride.
 * @return {number} Area.
 */


function linearRingss(flatCoordinates, offset, endss, stride) {
  var area = 0;

  for (var i = 0, ii = endss.length; i < ii; ++i) {
    var ends = endss[i];
    area += linearRings(flatCoordinates, offset, ends, stride);
    offset = ends[ends.length - 1];
  }

  return area;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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